import { render, staticRenderFns } from "./user.vue?vue&type=template&id=fcb6f678"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
import style0 from "./user.vue?vue&type=style&index=0&id=fcb6f678&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcb6f678')) {
      api.createRecord('fcb6f678', component.options)
    } else {
      api.reload('fcb6f678', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=fcb6f678", function () {
      api.rerender('fcb6f678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/user.vue"
export default component.exports